import { parseISO } from "date-fns";
import { BookingHour } from "../../data";

export function getBookingHourFromBookingDate(
  bookingHours: BookingHour[],
  bookingDate: string
) {
  const dayOfWeek = parseISO(bookingDate).getDay();
  const bookingHour = bookingHours.find((bh) => bh.dayOfWeek === dayOfWeek);

  return bookingHour;
}
